import { render } from "./DSidebar.vue?vue&type=template&id=974a1418"
import script from "./DSidebar.vue?vue&type=script&lang=js"
export * from "./DSidebar.vue?vue&type=script&lang=js"

import exportComponent from "F:\\weblocal\\taxe.local\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__